import { Link } from "@chakra-ui/react";
import * as React from "react";

function ExternalLink({ href, text }) {
  return (
    <Link
      color={"esg_blue"}
      isExternal
      href={href}>
      {text}
    </Link>
  );
}

export default ExternalLink;